(function(){
  var STORAGE_KEY = 'naara_popup_v1';
  if (localStorage.getItem(STORAGE_KEY)) return;
  function showPopup() {
    var overlay = document.getElementById('naara-popup-overlay');
    if (overlay) overlay.classList.add('naara-active');
  }
  function hidePopup(save) {
    var overlay = document.getElementById('naara-popup-overlay');
    if (overlay) overlay.classList.remove('naara-active');
    if (save) localStorage.setItem(STORAGE_KEY, '1');
  }
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(showPopup, 2000);
    var closeBtn = document.getElementById('naara-popup-close');
    if (closeBtn) closeBtn.addEventListener('click', function(){ hidePopup(true); });
    var overlay = document.getElementById('naara-popup-overlay');
    if (overlay) overlay.addEventListener('click', function(e){ if(e.target===overlay) hidePopup(true); });
    var form = document.getElementById('naara-popup-form');
    if (form) form.addEventListener('submit', function(e){
      e.preventDefault();
      var emailInput = document.getElementById('naara-popup-email');
      var email = emailInput ? emailInput.value.trim() : '';
      if (!email) return;
      var submitBtn = document.getElementById('naara-popup-submit');
      if (submitBtn) submitBtn.disabled = true;
      var body = new URLSearchParams();
      body.append('form_type', 'customer');
      body.append('utf8', '✓');
      body.append('contact[email]', email);
      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString()
      }).finally(function(){
        form.style.display = 'none';
        var success = document.getElementById('naara-popup-success');
        if (success) success.classList.add('naara-visible');
        localStorage.setItem(STORAGE_KEY, '1');
      });
    });
  });
})();
